import React from "react";
import { Button, Typography, Link } from "@material-ui/core";

import { useMediaQuery, Context } from "react-responsive";

import { Context as PortalContext } from "../context/portal.context";

import DownArrow from "@material-ui/icons/ExpandMore";
import RedRock from "../images/Red-Rock.jpg";
import Amex from "../images/amex.png";
import ad1 from "../images/testad1.jpg";
import ad2 from "../images/testad2.jpg";
import ad3 from "../images/ad3.jpg";
import ad4 from "../images/test4.jpg";



const Footer = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const { state } = React.useContext(PortalContext);

  const preventDefault = (event) => event.preventDefault();

  return (
    <div style={{ width: "100%", paddingBottom: isTabletOrMobile ? 70 : 0 }}>
      <div
        style={{
          maxHeight: 90,
          height: 56,
          backgroundColor: "white",
          borderTop: "1px solid rgb(227, 230, 231)",
          borderBottom: "1px solid rgb(227, 230, 231)",
          width: "100%",
          marginTop: 50,
          display: "flex",
          overflow: "hidden",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: 5,
        }}
      >
        {/* <img alt="footer Add" src={ad4}/> set height to 90 when using image*/}
        {/*
        <Button endIcon={<DownArrow />}>Settings & Profile</Button>
        <Button endIcon={<DownArrow />}>Help</Button>
        <Button endIcon={<DownArrow />}>Contact Us</Button>*/}
      </div>
      <div
        style={{
          width: "100%",
          padding: 25,
          display: "flex",
          flexDirection: isTabletOrMobile ? "column" : "row",
          justifyContent: "center",
          backgroundColor: "white",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            maxWidth: isTabletOrMobile ? "100%" : 1300,
            width: isTabletOrMobile ? "100%" : 1300,
            display: "flex",
            flexDirection: isTabletOrMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!isTabletOrMobile ? (
            <Typography
              variant={"caption"}
              style={{ textAlign: "left", color: "grey" }}
            >
              © <x-lang>Convenient Payments dba Intellipay, All rights reserved.</x-lang>
              <br></br>
              <x-lang>Company Americas, New York, NY.</x-lang> <br></br>
              <x-lang>Convenient Payments is a registered ISO/MSP of Woodforest Bank,
              Houston, TX.</x-lang>
            </Typography>
          ) : null}

          {/*<div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    textAlign: 'center',
                    marginTop: 10,
                }}
            >
                <Typography variant={'caption'} style={{ marginRight: 8 }}>
                    Powered by
                </Typography>
                <img src={IntellipayLogo} height={25} />
            </div>*/}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: isTabletOrMobile ? "center" : "flex-end",
                width: "100%",
              }}
            >
              {/* <span style={{ color: "#006195" }}>disclosures</span>
              <div
                style={{
                  marginLeft: 15,
                  marginRight: 15,
                  height: 15,
                  width: 1,
                  background: "#006195",
                }}
              />
              <span style={{ color: "#006195" }}>terms</span>
              <div
                style={{
                  marginLeft: 15,
                  marginRight: 15,
                  height: 15,
                  width: 1,
                  background: "#006195",
                }}
              /> */}

              <Link
                href="https://intellipay.com/privacy-policy/"
                target="_blank"
              >
                <x-lang>Privacy Policy</x-lang>
              </Link>
              {/* <div
                style={{
                  marginLeft: 15,
                  marginRight: 15,
                  height: 15,
                  width: 1,
                  background: "#006195",
                }}
              />
              <span style={{ color: "#006195" }}>accessibility</span> */}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: 10,
                width: "100%",
                justifyContent: isTabletOrMobile ? "center" : "flex-end",
              }}
            >
              <Link href={`tel:855-872-6632`}>(855) 872-6632</Link>

              <div
                style={{
                  marginLeft: 15,
                  marginRight: 15,
                  height: 15,
                  width: 1,
                  background: "#006195",
                }}
              />

              <Link href={`mailto:support@intellipay.com`}>
                support@intellipay.com
              </Link>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: 10,
                width: "100%",
                justifyContent: isTabletOrMobile ? "center" : "flex-end",
              }}
            >
              {" "}
              <Typography
                variant={"subtitle1"}
                style={{ textAlign: "left", color: "#0A4E8B" }}
              >
                <x-lang>Merchant</x-lang>: {state.merchantName} ({state.merchantID})
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
